/**
 *
 * Button
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import AKButton from '@atlaskit/button';

function getStyles({ currentTheme, themeProps, ...componentProps }) {
  const {
    disabledCursor,
    width,
    opacity,
    fontSize,
    fontWeight,
    background,
    height,
    padding,
    border,
    floatRight,
    margin,
    color,
    appearance,
    justifyContent,
  } = componentProps || {};
  const { buttonStyles, ...rest } = currentTheme(themeProps);
  return {
    buttonStyles: {
      ...buttonStyles,
      background: appearance === 'primary' ? '#0A7EF9' : background || buttonStyles.background,
      width: width ? `${width}px` : 'auto',
      height: height || '40px',
      opacity,
      color: appearance === 'primary' ? '#ffffff' : color || buttonStyles.color,
      float: floatRight ? 'right' : null,
      fontSize: fontSize || '12px',
      fontWeight: appearance === 'primary' ? '500' : fontWeight || 'normal',
      padding: padding || '2px 8px',
      margin,
      borderRadius: '5px',
      cursor: disabledCursor ? 'not-allowed' : 'pointer',
      justifyContent,
      border,
      '&:hover': {
        opacity: '1',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: 'none',
      },
    },
    ...rest,
  };
}

function Button(props) {
  const { loading, children, iconBefore, ...others } = props;
  return (
    <AKButton
      {...others}
      isLoading={loading}
      iconBefore={iconBefore}
      theme={(currentTheme, themeProps) => getStyles({ currentTheme, themeProps, ...props })}
    >
      {children}
    </AKButton>
  );
}

Button.propTypes = {
  loading: PropTypes.bool,
};

export default memo(Button);
